import { graphql, useStaticQuery } from "gatsby"
import { TNavigation } from "../types"

const footerColumnFour = (): TNavigation => {

  const query = useStaticQuery(
    graphql`
      query {
        allNavigation(filter: { title: { eq: "Footer Column 4" } }) {
          nodes {
            title
            json
          }
        }
      }
    `)

  return query.allNavigation.nodes[0]

}

export default footerColumnFour
